import {
  TableRoot,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  TableHeaderCell,
} from './Table';

// Compound object export for ergonomic API: Table.Root, Table.Row, etc.
export const Table = {
  Root: TableRoot,
  Header: TableHeader,
  Body: TableBody,
  Row: TableRow,
  Cell: TableCell,
  HeaderCell: TableHeaderCell,
};

